import { IdNameModel } from '@abb-procure/data';
import {
  Component,
  booleanAttribute,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputSelect } from '../input-select/input-select.component';

@Component({
  selector: 'procure-input-keyword',
  templateUrl: './input-keyword.component.html',
  styleUrl: './input-keyword.component.scss',
  imports: [InputSelect],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InputKeyword {
  readonly id = input<string | null>(null);
  readonly label = input<string>('Keywords');
  readonly control = input.required<FormControl>();
  readonly keywords = input<IdNameModel[] | string[] | null>(null);

  readonly showMode = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });

  readonly addable = input<boolean, boolean | string>(true, {
    transform: booleanAttribute,
  });

  readonly showTooltip = input<boolean, boolean | string>(true, {
    transform: booleanAttribute,
  });

  readonly changed = output<IdNameModel[]>();

  protected get value(): IdNameModel[] {
    const control = this.control();

    if (control?.value != null) {
      return control.value;
    }

    return [];
  }

  onChange(): void {
    this.changed.emit(this.value);
  }
}
